export default __webpack_public_path__ + "static/image12-803d703056fe11d756bd656961657ee6.jpeg";